import React, { CSSProperties, useEffect } from "react";
import styles from "./StoneityButton.module.css";

interface StoneityButtonProps {
  buttonText?: string;
  onClick?: any;
  buttonClass?: string;
  buttonStyle?: 'dark' | 'light';
  width?: string | number;
  height?: string | number;
  icon?: React.ReactNode;
  iconStyle?: React.CSSProperties;
  isSelected?: boolean;
  disabled?: boolean;
  iconPosition?: 'start' | 'end';
}

const StoneityButton = (props: StoneityButtonProps) => {
  const { buttonText, buttonClass, buttonStyle, width, height, icon, iconStyle, isSelected, disabled, iconPosition } = props;

  const [customStyle, setCustomStyle] = React.useState<CSSProperties>(Object.assign({}));

  useEffect(() => {
    const style = Object.assign({});

    if (width !== undefined && width !== null) {
      style.width = width;
    }

    if (height !== undefined && height !== null) {
      style.height = height;
    }

    setCustomStyle(style);
  }, [width, height]);

  return (
    <button
      className={`${styles.stoneityButton} ${styles[disabled ? 'disabled' : '']} ${styles[buttonStyle ? buttonStyle : 'dark']} ${styles[buttonClass ?? ""]} ${styles[isSelected ? 'active' : '']}`}
      style={customStyle}
      onClick={props.onClick}>
      {iconPosition === 'start' && icon && <div style={iconStyle}>{icon}</div>}
      <span>{buttonText}</span>
      {iconPosition === 'end' && icon && <div style={iconStyle}>{icon}</div>}
    </button>
  );
};

export default StoneityButton;
